export default "__VITE_ASSET__DCz7lf1___"